export const leftContainerParams = {
    userGuide:"User-Guide.pdf",
    demoVideo:"Comms Builder Demo video Link V5.mp4"
};